import { useCallback, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

const useTaskAssignmentDialogContentState = () => {
  const [
    taskAssignmentDialogContentKey,
    setTaskAssignmentDialogContentKey
  ] = useState(uuidv4());

  const [searchCriteria, setSearchCriteria] = useState({
    keywords: [],
    criterions: {}
  });

  const resetTaskAssignments = useCallback(() => {
    setTaskAssignmentDialogContentKey(uuidv4());
  }, []);

  return {
    taskAssignmentDialogContentKey,
    searchCriteria,
    setSearchCriteria,
    resetTaskAssignments
  };
};

export default useTaskAssignmentDialogContentState;
